export const ButtonType = {
  IDENTIFY: 'identify',
  MEET_CONTEST: 'meetContest',
  REGISTER: 'register',
  PLAY: 'play',
  ANCHOR: 'anchor',
  REGULATIONS: 'regulations',
  FINAL_DAY_STUDENT: 'finalDayStudent',
  FINAL_LOCKED: 'finalLocked',
  FINALISTS_LIST: 'finalistsList',
  REGISTERFORFINAL: 'registerForFinal',
};

